import { Table } from "common/Table/Table"
import { useDebounce } from "hooks/useDebounce"
import { Fragment, useCallback, useEffect, useState } from "react";
import UserService from "services/user.service"
import { exportToCSV, formatDate } from "utils/funcs"
import swal from "sweetalert";
import { DATE } from "./trainings/WeeklyStats"
import DatePicker from "react-datepicker"
import moment from "moment";
import { useNotifications } from "hooks/useNotification";
import CopyText from "common/CopyText";
import { Modal } from "common/Modal";

const service = new UserService()

export const DealerContacts = () => {
  const columns = [
    {
      key: "badge_id",
      dbColName: "_id",
      title: "Ad id",
      render: (id) => (
        <CopyText copyText={id} text={`${id.toString().slice(0, 8)}...`} />
      ),
    },
        {key: "firstName", dbColName: "firstName", title: "firstName"},
        {key: "lastName", dbColName: "lastName", title: "lastName"},
        {key: "badgeId", dbColName: "badgeId", title: "badgeId"},
        {key: "phone", dbColName: "phone", title: "phone"},
        {key: "countryCode", dbColName: "countryCode", title: "country Code"},
        {key: "email", dbColName: "email", title: "email"},
        {key: "source", dbColName: "source", title: "source"},
        {key: "companyId", dbColName: "companyId", title: "company Id"},
        {key: "notes", dbColName: "notes", title: "notes"},
        {key: "createdAt", dbColName: "createdAt", title: "createdAt", render: date => formatDate(date)},
          {
              key: "actions",
              title: "actions",
              freeze: true,
              freezeIndex: "right-0",
              render: (
             
                row
              ) => {
                return (
                    <div className="flex items-center gap-2">
                   
                      <button
                        onClick={() => handleDelete(row._id)}
                        className="  text-red-500 rounded-md text-xs p-2 "
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="h-6 w-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                          />
                        </svg>
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          setShowModal(true);
                          setState({
                            id: row._id,
                            firstName: row.firstName,
                            lastName: row.lastName,
                            phone: row.phone,
                            email: row.email,
                            notes: row.notes,
                          });
                        }}
                        className="  text-blue-500 rounded-md text-xs p-2 "
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="h-6 w-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                          />
                        </svg>
                      </button>
                    </div>
                  )
              },
            },
  ];

  const [data, setData] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [state, setState] = useState({ id: '', firstName: '', lastName: '', phone: '', email: '', notes: '' });
  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: 100,
    badgeId: "",
    phoneNumber: "",
    fullName: "",

    date: "YEARTODATE",
  
  });

  const debounced = useDebounce(pagination, 500);
  const { successMessage } = useNotifications();

  const fetchData = useCallback(() => {
    setLoading(true);
    service
      .dealersContacts(debounced)
      .then((resp) => {
            setData(resp.data.data);
        setTotalItems(+resp.data.totalDocument);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [debounced]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleExport = () => {
    setExporting(true);
    service
      .dealersContacts({
        ...pagination,
        pageNumber: "",
        pageSize: "",
        isDownload: "true",
      })
      .then((resp) => {
        exportToCSV(resp.data.data, "reps");
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setExporting(false);
      });
  }

  const handleDelete = (id) => {
    swal({
      title: "Are you sure, you want to delete this ad?",
      icon: "warning",
      className: "w-[500px]",
      buttons: {
        cancel: {
          text: "Cancel",
          visible: true,
        },
        confirm: {
          text: "Delete",
          className: "bg-primary text-white",
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setLoading(true);
        service
          .deleteMedia(id)
          .then((resp) => {
            if (resp.data.success) {
              successMessage("Media ad deleted successfully");
              const shallowCopy = [...data];
              const newData = shallowCopy.filter((d: any) => d._id !== id);
              setData(newData);
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)

    const payload = {
      firstName: state.firstName,
      lastName: state.lastName,
      phone: state.phone,
      email: state.email,
      notes: state.notes,
    }    

    service
      .updateContactAd(state.id, payload)
      .then((resp) => {
        if (resp.data.success) {
          successMessage("Media ad updated successfully")
          setShowModal(false)
          fetchData()
        }
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const clearFilter = () => {
    setPagination({
      pageNumber: 1,
      phoneNumber: "",
      pageSize: 500,
      badgeId: "",
      fullName: "",
      date: "YEARTODATE",
    });
  }

  return (
    <Fragment>
      <div className="flex flex-col mb-4">
        <h1 className="page-title">
          Dealer Contacts
        </h1>
        <p className="page-subtitle">View all</p>
      </div>
      <Table
        data={data}
        handleExport={handleExport}
        pagination={pagination}
        setData={setData}
        exporting={exporting}
        setPagination={setPagination}
        showSearch={false}
        loadingData={loading}
        filters={
          <Filters
            clearFilter={clearFilter}
            pagination={pagination}
            setPagination={setPagination}
          />
        }

        totalItems={totalItems}
        columns={columns}
      />

      <Modal
            width="w-full md:w-1/3"
            showModal={showModal}
            setShowModal={setShowModal}
            title="Update Media Ad"
          >
 <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <input
            type="text"
            placeholder="First Name"
            value={state.firstName}
            onChange={(e) => setState({ ...state, firstName: e.target.value })}
            className="w-full px-3 py-2 text-sm"
          />
          <input
            type="text"
            placeholder="Last Name"
            value={state.lastName}
            onChange={(e) => setState({ ...state, lastName: e.target.value })}
            className="w-full px-3 py-2 text-sm"
          />
          <input
            type="email"
            placeholder="Email"
            value={state.email}
            onChange={(e) => setState({ ...state, email: e.target.value })}
            className="w-full px-3 py-2 text-sm"
          />
          <input
            type="text"
            value={state.phone}
            placeholder="Phone"
            onChange={(e) => setState({ ...state, phone: e.target.value })}
            className="w-full px-3 py-2 text-sm"
          />

        
          <textarea
            value={state.notes}
            placeholder="Notes"
            rows={3}
            onChange={(e) => setState({ ...state, notes: e.target.value })}
            className="w-full px-3 py-2 text-sm"
          />

          <button
            type="submit"
            className="bg-ink hover:bg-gray-800 disabled:cursor-not-allowed rounded-lg font-medium text-sm disabled:bg-green-300 text-white p-2.5"
          >
            Save
          </button>
        </form>
          </Modal>
    </Fragment>
  );
};


export const Filters = ({ clearFilter, pagination, setPagination }: any) => {
  const filters = { ...pagination };
  delete filters.pageNumber;
  delete filters.pageSize;
  const hasFilters = Object.values(filters).some((item) => item);

  const [showCustom, setShowCustom] = useState(false);
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);

  const handleChangeDates = (dates) => {
    const [start, end] = dates;

    setStartDate(start);
    setEndDate(end);

    if ((!start && !end) || end) {
      setPagination({
        ...pagination,
        date: `${moment(start).format("YYYY-MM-DD")},${moment(end).format("YYYY-MM-DD")}`,
      });
    }
  };

  return (
    <div className="flex flex-1 items-center gap-4">
      <input
        className="flex-1 px-3 py-2 text-sm"
        type="text"
        value={pagination.badgeId}
        placeholder="Badge ID"
        onChange={(e) => {
          setPagination({
            ...pagination,
            badgeId: e.target.value,
          });
        }}
      />
      <input
        className="w-full px-3 py-2 text-sm"
        type="text"
        value={pagination.fullName}
        placeholder="Search by Name"
        onChange={(e) => {
          setPagination({
            ...pagination,
            fullName: e.target.value,
          });
        }}
      />
      <input
        placeholder="Phone number"
        className="flex-1 px-3 py-2 text-sm"
        type="text"
        value={pagination.phoneNumber}
        onChange={(e) => {
          setPagination({
            ...pagination,
            phoneNumber: e.target.value,
          })
        }}
      />
      <div className="flex flex-1 flex-col gap-1 min-w-[150px]">
        {/* <label className="field-label">Signed Rep Date</label> */}
        <select
          value={pagination.date}
          className="w-60 px-3 py-2 text-sm"
          onChange={(e) => {
            if (e.target.value !== "CUSTOM") {
              setPagination({ ...pagination, date: e.target.value });
            } else {
              setShowCustom(true);
            }
          }}
        >
          <option>Select</option>
          {DATE.map((item) => (
            <option value={item} key={item}>
              {item}
            </option>
          ))}
        </select>
        {showCustom && (
          <DatePicker
            selected={startDate}
            placeholderText="Select range"
            onChange={handleChangeDates}
            startDate={startDate}
            endDate={endDate}
            isClearable
            className="z-100 ml-2 py-2 w-60"
            customInput={
              <input
                placeholder="Select date"
                className="w-60 px-3 py-2 text-sm"
              />
            }
            selectsRange
            selectsDisabledDaysInRange
          />
        )}
      </div>
     
      {hasFilters && (
        <button
          onClick={() => {
            clearFilter();
          }}
          className="bg-ink hover:bg-gray-800 whitespace-nowrap rounded-lg text-white px-3 py-2 text-sm "
        >
          Clear Filters
        </button>
      )}
    </div>
  );
};
